import React, { useState } from "react";
import { IoIosArrowDropupCircle } from "react-icons/io";
import "./BackToTop.css";

const BackToTop = () => {
    const [visible, setVisible] = useState(false);
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true);
        } else if (scrolled <= 300) {
            setVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    window.addEventListener("scroll", toggleVisible);

    return (
        <div
            className="backToTop"
            style={{ display: visible ? "inline" : "none" }}
        >
            <button onClick={scrollToTop} aria-label="Back to top">
                <IoIosArrowDropupCircle />
            </button>
        </div>
    );
};

export default BackToTop;
